<template>
    <div class="container-edit-principal">
        <HeadDetailsGama v-on:openModal="openModal" :titleHead="'Detalhes usuário'" :btnEdit="!(editUserData.status == 2)" :btnResetPassword="corretor == true ? editUserData.aprovado == true ? true : false : editUserData.status == 0 && editUserData.contaId !== null ? true : false" :btnApproveUser="editUserData.status == 2"></HeadDetailsGama>
        <div class="container-edit-form mt-4 ml-2">
            <b-form>
                <div class="title-1 title">Dados Básicos</div>
                <div class="conteudo-dados-basicos">

                  <div class="basicos-nome">
                    <b-form-group
                        class="edit-group"
                        id="edit-group-name"
                        label="Nome:"
                        label-for="input-name"
                    >
                        <b-form-input
                        id="input-name"
                        name="input-name"
                        type="text"
                        v-validate="{ alpha_spaces: true, required: true }"
                        :state="validateState('input-name')"
                        v-model="editUserData.nome"
                        placeholder="Digite o nome do usuário"
                        class="rounded"
                        required
                        ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="basicos-email">
                    <b-form-group
                        id="edit-group-email"
                        label="E-mail:"
                        label-for="input-email"
                    >
                        <b-form-input
                        id="input-email"
                        name="input-email"
                        v-validate="{ required: true, email: true }"
                        :state="validateState('input-email')"
                        v-model="editUserData.email"
                        type="email"
                        placeholder="Digite o e-mail do usuário"
                        class="rounded"
                        required
                        ></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="basico-data">
                    <b-form-group
                        id="edit-group-dateBirth"
                        label="Data de Nascimento:"
                        label-for="input-dateBirth"
                    >
                        <b-form-datepicker
                        id="input-dateBirth"
                        name="dateBirth"
                        required
                        v-model="editUserData.dataNascimento"
                        :placeholder="$lang.Common.DatePlaceholder"
                        v-validate="{ required: true }"
                        :state="validateState('dateBirth')"
                        class="rounded"
                        ></b-form-datepicker>
                    </b-form-group>
                  </div>
                </div>

                <div class="conteudo-dados-basicos">
                  <div class="basico-creci" v-if="corretor == true">
                    <b-form-group
                        v-if="showCreci"
                        id="edit-group-creci"
                        label="CRECI:"
                        label-for="input-creci"
                    >
                        <b-form-input
                        id="input-creci"
                        name="input-creci"
                        v-model="editUserData.creci"
                        v-validate="{ required: true }"
                        :state="validateState('input-creci')"
                        type="text"
                        placeholder="Digite o número do CRECI"
                        class="rounded"
                        required
                        ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="basico-uf" v-if="corretor == true">
                    <b-form-group
                        v-if="showCreci"
                        id="edit-group-uf-creci"
                        label="UF:"
                        label-for="input-uf-creci"
                    >
                        <b-form-select
                        id="input-uf-creci"
                        name="input-uf-creci"
                        v-validate="{ required: true }"
                        :options="statesAcronym"
                        :state="validateState('input-uf-creci')"
                        v-model="editUserData.ufCreciId"
                        type="text"
                        placeholder="Selecione"
                        required
                        ></b-form-select>
                    </b-form-group>
                  </div>
                <div :class="corretor == true ? 'basico-dados' : 'basico-dados-clintes'">
                  <b-form-group id="edit-group-rg" label="RG:" label-for="input-rg" :class="showCreci ? '':'edit-rg-administrator'">
                      <b-form-input
                      id="input-rg"
                      name="input-rg"
                      v-model="editUserData.rg"
                      v-validate="{ required: true }"
                      :state="validateState('input-rg')"
                      type="text"
                      placeholder="Digite o RG do usuário"
                      class="rounded"
                      required
                      ></b-form-input>
                  </b-form-group>
                </div>
                <div :class="corretor == true ? 'basico-dados' : 'basico-dados-clintes'">
                  <b-form-group id="edit-group-cpf" label="CPF:" label-for="input-cpf" :class="showCreci ? '':'edit-cpf-administrator'">
                      <b-form-input
                      id="input-cpf"
                      name="input-cpf"
                      v-model="editUserData.cpf"
                      :disabled="true"
                      v-validate="{ required: true, length: 14, numeric: false }"
                      :state="validateState('input-cpf')"
                      type="text"
                      placeholder="___.___.___-__"
                      required
                      v-mask="['###.###.###-##']"
                      class="rounded"
                      ></b-form-input>
                  </b-form-group>
                </div>
                <div :class="corretor == true ? 'basico-dados' : 'basico-dados-clintes'">
                  <b-form-group
                      id="edit-group-cellphone"
                      label="Celular:"
                      label-for="input-cellphone"
                  >
                      <b-form-input
                      id="input-cellphone"
                      name="input-cellphone"
                      v-model="editUserData.celular"
                      v-validate="{ required: true, numeric: false, length: 15 }"
                      :state="validateState('input-cellphone')"
                      type="text"
                      placeholder="(__) _____-____"
                      v-mask="['(##) #####-####']"
                      class="rounded"
                      required
                      ></b-form-input>
                  </b-form-group>
                </div>
                 <div :class="corretor == true ? 'basico-dados' : 'basico-dados-clintes'">
                  <b-form-group
                      id="edit-group-comercial-phone"
                      label="Telefone:"
                      label-for="input-comercial-phone"
                      class="teste"
                  >
                      <b-form-input
                      id="input-comercial-phone"
                      name="input-comercial-phone"
                      v-model="editUserData.telefoneComercial"
                      v-validate="{ required: true, numeric: false, length:14 }"
                      :state="validateState('input-comercial-phone')"
                      type="text"
                      placeholder="(__) ____-____"
                      v-mask="['(##) ####-####']"
                      class="rounded"
                      required
                      ></b-form-input>
                  </b-form-group>
                 </div>
                </div>

              <div class="title-2">Endereço</div>
               <div class="conteudo-dados-basicos">
                 <div class="basico-creci">
                  <b-form-group id="edit-group-cep" label="CEP:" label-for="input-cep" class="teste">
                      <b-form-input
                      id="input-cep"
                      name="input-cep"
                      v-model="editUserData.cep"
                      v-validate="{ required: true, numeric: false, length: 9 }"
                      :state="validateState('input-cep')"
                      @blur="searchAndress"
                      type="text"
                      placeholder="_____-___"
                      v-mask="['#####-###']"
                      class="rounded"
                      required
                      ></b-form-input>
                  </b-form-group>
                 </div>

                <div class="basico-endereco">
                  <b-form-group
                      id="edit-group-city"
                      label="Cidade:"
                      label-for="input-city"
                  >
                      <b-form-input
                      id="input-city"
                      name="input-city"
                      v-model="editUserData.cidade"
                      :disabled="true"
                      v-validate="{ required: true, alpha_spaces: true }"
                      :state="validateState('input-city')"
                      type="text"
                      placeholder="Digite o nome da cidade"
                      class="rounded"
                      required
                      ></b-form-input>
                  </b-form-group>
                </div>

                <div class="basico-endereco">
                  <b-form-group
                      id="edit-group-address"
                      label="Endereço:"
                      label-for="input-address"
                  >
                      <b-form-input
                      id="input-address"
                      name="input-address"
                      :disabled="true"
                      v-model="editUserData.endereco"
                      v-validate="{ required: true, alpha_spaces:true }"
                      :state="validateState('input-address')"
                      type="text"
                      placeholder="Digite o endereço do usuário"
                      class="rounded"
                      required
                      ></b-form-input>
                  </b-form-group>
                </div>

                <div class="basico-endereco">
                  <b-form-group
                      id="edit-group-district"
                      label="Bairro:"
                      label-for="input-district"
                  >
                      <b-form-input
                      id="input-district"
                      name="input-district"
                      :disabled="true"
                      v-model="editUserData.bairro"
                      v-validate="{ required: true, alpha_spaces: true }"
                      :state="validateState('input-district')"
                      type="text"
                      placeholder="Digite o endereço do usuário"
                      class="rounded"
                      required
                      ></b-form-input>
                  </b-form-group>
                </div>

                <div class="basico-endereco">
                  <b-form-group
                      id="edit-group-number"
                      label="Número:"
                      label-for="input-number"
                  >
                      <b-form-input
                      id="input-number"
                      name="input-number"
                      v-model="editUserData.numero"
                      v-validate="{ required: true }"
                      :state="validateState('input-number')"
                      type="text"
                      placeholder="Digite o número do usuário"
                      class="rounded"
                      required
                      ></b-form-input>
                  </b-form-group>
                </div>
                </div>
                <div class="container-buttons-form">
                    <button v-on:click="backPage" class="button-cancel">
                    Cancelar
                    </button>
                    <button class="button-save" v-on:click="onSubmit">Salvar</button>
                </div>
            </b-form>
        </div>

        <div class="modals">
            <b-modal
            hide-footer
            centered
            ref="reset-password-modal"
            id="reset-password-modal"
            >
            <template #modal-title>
              <div class="header-title">Restaurar Senha</div>
            </template>
            <div class="container-modal-rest">
                <div class="container-icon-lock">
                <i class="fas fa-unlock"></i>
                </div>

                <div class="message-container">
                <div class="message">Deseja restaurar a senha do usuário?</div>
                </div>

                <div class="container-buttons">
                <button @click="closeModal('reset-password-modal')" class="cancel-button">NÃO</button>
                <button @click="resetPassword" class="confirm-button">SIM</button>
                </div>
            </div>

            </b-modal>

            <b-modal
            hide-footer
            centered
            ref="reset-password-notice"
            id="reset-password-notice"
            >
            <template #modal-title>
                <div class="header-title">Senha Resetada</div>
            </template>
            <div class="container-modal-rest">

                <div class="container-icon-lock">
                <i class="fas fa-unlock"></i>
                </div>

                <div class="message-container">
                <div v-if="this.editCustomer == true" class="message">Uma senha temporária foi gerada para {{editUserData.nome}}!</div>
                <div v-if="this.editCustomer == false" class="message">Uma senha temporária foi gerada e enviada para o email do usuário!</div>

                </div>

                <div class="container-buttons">
                <button @click="closeModal('reset-password-notice')" class="finish-button">FINALIZAR</button>
                </div>
            </div>

            </b-modal>

            <b-modal
            hide-footer
            centered
            ref="delete-user-modal"
            id="delete-user-modal"
            >
            <template #modal-title>
                <div class="header-title">Exclusão</div>
            </template>
            <div class="container-modal-rest">
                <div class="container-icon-lock">
                    <i class="fas fa-trash"></i>
                </div>

                <div class="message-container">
                <div class="message">Deseja excluir esse usuário?</div>
                </div>

                <div class="container-buttons">
                <button @click="closeModal('delete-user-modal')" class="cancel-button">NÃO</button>
                <button @click="deleteUser" class="confirm-button">SIM</button>
                </div>
            </div>

            </b-modal>

            <b-modal
            hide-footer
            centered
            ref="inactivate-user-modal"
            id="inactivate-user-modal"
            >
            <template #modal-title>
              <div class="header-title">{{corretor === true ? editUserData.aprovado ? 'APROVAR' : 'REPROVAR' : editUserData.status === 0 ? 'INATIVAR' : 'ATIVAR'}}</div>
            </template>
            <div class="container-modal-rest">
                <div class="container-icon-lock">
                    <i v-if="corretor === true ? editUserData.aprovado : editUserData.status === 0 ? true : false" class="fas fa-times" style="color:red"></i>
                    <i v-else class="fa fa-check text-success icone-grid"></i>
                </div>

                <div class="message-container">
                <div class="message">Deseja {{corretor === true ? editUserData.aprovado ? 'APROVAR' : 'REPROVAR' : editUserData.status === 0 ? 'INATIVAR' : 'ATIVAR'}} esse usuário?</div>
                </div>

                <div class="container-buttons">
                <button @click="closeModal('inactivate-user-modal')" class="cancel-button">NÃO</button>
                <button @click="inactivateUser" class="confirm-button">SIM</button>
                </div>
            </div>

            </b-modal>

            <b-modal
            hide-footer
            hide-header
            centered
            ref="approve-user-modal"
            id="approve-user-modal"
            >
            <div class="container-modal-rest">
                <div class="close-modal"><i @click="closeModal('approve-user-modal')" class="fas fa-times-circle"></i></div>
                <div class="container-icon-lock">
                    <i class="fas fa-thumbs-up"></i>
                </div>

                <div class="message-container">
                <div class="message">Deseja aprovar este usuário?</div>
                </div>

                <div class="container-buttons">
                <button @click="closeModal('approve-user-modal')" class="cancel-button">CANCELAR</button>
                <button @click="approveReproveUser(false)" class="reprove-button">REPROVAR</button>
                <button @click="approveReproveUser(true)" class="confirm-button">APROVAR</button>
                </div>
            </div>

            </b-modal>
        </div>
    </div>
</template>

<script>
import UserEditForm from '@/views/private/realestate/users/components/UserEditForm/UserEditForm.js'
export default UserEditForm
</script>
<style scoped>
.header-title{
  color: white;
}
.conteudo-dados-basicos {
  display: flex;
  margin-top: 0.5rem;
  column-gap: 5px;
}
.basico-data{
  width: 35%;
}
.basicos-email {
  width: 30%;
}
.basicos-nome{
  width: 35%;
}
.basico-creci {
  width: 11%;
}
.basico-uf {
  width: 11%;
}
.basico-dados {
  width: 19.5%;
}
.basico-dados-clintes{
  width: 25%;
}
.basico-endereco {
width: 22.25%;
}
.container-edit-principal{
    background-color: white;
    padding: 10px;
    border: 1px solid #d1d9dd;
    border-radius: 6px;
}

.container-buttons-form{
    margin-top: 2rem;
    grid-row: 6;
    grid-column: 1/11;
}

.title-1,
.title-2{
    margin-top: 3%;
    font-size: 18px;
    font-weight: bold;
    color: #008148;
    width: 150px;
}

.title-1{
  grid-row: 1;
}

.title-2{
  grid-row: 4;
}

.container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
}

.button-cancel,
.button-save{
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}
.button-cancel{
  background-color: #a60e0e;
  color: #ffffff;
}
.button-save{
  background-color: #008148;
  color: white;

}

/* management modals */
.container-modal-rest{
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.close-modal{
  display: flex;
  width: 100%;
  font-size: 20px;
  color:#A8A8A8;
  cursor: pointer;
  justify-content: end;
}
.container-icon-lock{
  width: 100%;
  display: flex;
  justify-content: center;
  color:#008148;
  font-size: 36px;
}

.message-container{
  display: flex;
  width: 100%;
  justify-content: center;
}

.message{
  color: black;
  font-size: 16px;
  text-align: center;
}

.container-buttons{
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 30px;
}

.cancel-button,.confirm-button,.finish-button, .reprove-button{
  border: transparent;
  border-radius: 6px;
  width: 130px;
  height: 30px;

}

.cancel-button{
  color: white;
  background-color: #a60e0e;
}

.confirm-button, .finish-button{
  color: white;
  background-color: #008148;
}

.reprove-button{
    color: white;
    background-color: #db3939;
}

.finish-button{
  width: 190px !important;
}

.edit-rg-administrator{
    grid-column: 1/4 !important;
}
.edit-cpf-administrator{
    grid-column: 4/7 !important;
}

/* bootstrap css changes*/

.form-group{
  font-size: 15px;
  font-weight: 500;
}

.form-control{
  font-size: 13px !important;;
  width: 100%;
  height: 35px;
  border: 1px solid #D4D9DE;
  border-radius: 5px;
}

.custom-select{
  width: 100%;
  height: 35px;
  border: 1px solid #D4D9DE;
  border-radius: 5px;
}

.table-realtors thead, .table-realtors tbody{
  display: block;
}

.table-realtors tbody{
  overflow-y: auto;
  height: 520px;
}

.table-realtors th,
.table-realtors td {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/users/components/UserEditForm/UserEditForm.vue